import React, { PureComponent } from 'react';
import { Checkbox } from 'semantic-ui-react';

export default class DLToggle extends PureComponent {
    render() {
        const inlineStyle = { ...this.props.style };
        const props = {
            ...this.props,
            style: undefined,
        };
        return (
            <div className={ `semantic-wrapper ${ this.props.className }` }
            data-full-width={ this.props.fullWidth }
            data-name={ this.props.name }
            style={ inlineStyle }>
                <Checkbox toggle { ...props } />
            </div>
        );
    }
}

DLToggle.defaultProps = {
    className: '',
    style: {},
};
